import React from 'react'

const Humidity = () => {
  return (
    <div>
      <section class="inner-banner">
        <div class="thm-container">
          <h2> Product Details </h2>
          <div class="breadcumb">
            <a href="/">Chambers</a>
            <i class="fa fa-angle-right"></i>
            <span>Humidity Stability Chamber</span>
          </div>
        </div>
      </section>
      <div className='container py-4'>
        <div className='row d-flex' style={{ margin: "80px 0px" }}>
          <div className='col-lg-6 col-md-6 col-sm-12 col-xs-12'>
            <img src='/img/humidity.png' width={400}></img>
          </div>
          <div className='col-lg-6 col-md-6 col-sm-12 col-xs-12'>
            <h2 style={{ textDecoration: "underline" }}>Humidity Stability Chamber:</h2>
            <h4 style={{ textDecoration: "underline" }}>WLS-RFM-950</h4>
            <p className="mbot25">
              This instrument can widely be used in petroleum, chemical, pharmaceutical,
              sugar refining and food industries, as well as in related colleges, universities
              and scientific research institutions for measuring refractive index nD of
              transparent, semi transparent liquid. This instrument can also be used to
              measure the °Brix (BX) of the sugar solution, and correct the effect of
              temperature on the Brix automatically. In addition, this instrument can
              also display the temperature of the sample.
            </p>
            <p className='mbot25'>
              <h4 style={{ textDecoration: "underline" }}>Features & Benefits:</h4>
              <ul>
                <li>Fitted with digital temperature controller</li>
                <li>Excellent temperature accuracy & uniformity</li>
                <li>High grade stainless steel interior</li>
                <li>Powder coated exterior cabinet or epoxy coated SS304</li>
                <li>High density glass wool insulation</li>
                <li>Variety of optional accessories available</li>
                <li>Large models are having internal circulation system with inbuilt corrosion resistant pump.</li>
                <li>External circulation available on demand</li>
                <li>Various customized options available</li>
              </ul>
            </p>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Humidity
